import React, { useEffect } from "react";
// import LoginForm from "../forms/pageForms/loginForm";
import ResetPasswordForm from "../forms/pageForms/resetPasswordForm";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ResetPassword({}) {
  const { t } = useTranslation();
  useEffect(() => {}, []);

  const handleFormikSubmit = (values, actions) => {
    // console.log("Values: ", values);
    // console.log("Actions: ", actions);
  };

  return (
    <main className="registration">
      <section className="main-section">
        <h2>{t("resetPassword.title")}</h2>
        <section className="main-section-content">
          <ResetPasswordForm handleFormikSubmit={handleFormikSubmit} />
          <hr />
          <section className="text-center mt-3">
            <div className="d-flex justify-content-around">
              <p>{t("resetPassword.haveAccount")}</p>
              <Link to="/login">{t("resetPassword.login")}</Link>
            </div>

            <div className="d-flex justify-content-around">
              <p>{t("resetPassword.noAccount")}</p>
              <Link to="/signup/:id">{t("resetPassword.signUp")}</Link>
            </div>
          </section>
        </section>
      </section>
    </main>
  );
}
